import writeCookie from "./writeCookie";

const isUrlEn = function(url) {
  /*先抓URL判斷語系*/
  if (url.includes("/tc")) {
    writeCookie("hk-emphasis-language", "zh_HK", true); /*填入cookie*/
  } else if (url.includes("/en")) {
    writeCookie("hk-emphasis-language", "en", true);
  }
};
export default isUrlEn;
